import { Logo } from '@/components/brand/Logo';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/app/AuthProvider';

/**
 * Shown when a user has an auth session but no profile row yet — happens for
 * a brief moment between auth.users insert and the trigger that creates the
 * profile, or if the trigger errored.
 */
export function PendingPage() {
  const { signOut, refreshProfile, user } = useAuth();
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <Logo variant="symbol" tone="humus" className="mx-auto h-12 w-12" />
        <div className="space-y-2">
          <h1 className="text-2xl font-medium tracking-headline">Setting up your account</h1>
          <p className="text-sm text-muted-foreground">
            Hi {user?.email ?? 'there'} — we're finishing your profile. If this
            takes more than a few seconds, ask a Super Admin to add you.
          </p>
        </div>
        <div className="flex justify-center gap-2">
          <Button onClick={() => refreshProfile()}>Retry</Button>
          <Button variant="ghost" onClick={() => signOut()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
